import AliPay from "components/PaymentMethodIcons/AliPay";
import Bancontact from "components/PaymentMethodIcons/Bancontact";
import iDEAL from "components/PaymentMethodIcons/iDEAL";
import EPS from "components/PaymentMethodIcons/EPS";
import giropay from "components/PaymentMethodIcons/giropay";
import Przelewy24 from "components/PaymentMethodIcons/Przelewy24";
import SEPADirectDebit from "components/PaymentMethodIcons/SEPADirectDebit";
import Sofort from "components/PaymentMethodIcons/Sofort";
import AfterpayClearpay from "components/PaymentMethodIcons/AfterpayClearpay";
import Affirm from "components/PaymentMethodIcons/Affirm";
import ApplePay from "components/PaymentMethodIcons/ApplePay";
import GooglePay from "components/PaymentMethodIcons/GooglePay";
import WeChatPay from "components/PaymentMethodIcons/WeChatPay";
import GrabPay from "components/PaymentMethodIcons/GrabPay";
import Boleto from "components/PaymentMethodIcons/Boleto";
import Konbini from "components/PaymentMethodIcons/Konbini";
import OXXO from "components/PaymentMethodIcons/OXXO";
import FPX from "components/PaymentMethodIcons/FPX";
import { BsCreditCard } from "@hacknug/react-icons/bs";
import { RiBankLine } from "@hacknug/react-icons/ri";
import { COLORS } from "utils/styles";
import { PAYMENT_METHOD_TYPE } from "utils/constants/payment";

const CARD_ICON = () => <BsCreditCard size={28} color={COLORS.text} />;
const DEBIT_ICON = () => <RiBankLine size={28} color={COLORS.text} />;

export const PAYMENT_METHOD_TYPE_ICON_MAP = {
  [PAYMENT_METHOD_TYPE.CARD]: CARD_ICON,
  [PAYMENT_METHOD_TYPE.ALIPAY]: AliPay,
  [PAYMENT_METHOD_TYPE.BANCONTACT]: Bancontact,
  [PAYMENT_METHOD_TYPE.IDEAL]: iDEAL,
  [PAYMENT_METHOD_TYPE.GIROPAY]: giropay,
  [PAYMENT_METHOD_TYPE.P24]: Przelewy24,
  [PAYMENT_METHOD_TYPE.EPS]: EPS,
  [PAYMENT_METHOD_TYPE.SOFORT]: Sofort,
  [PAYMENT_METHOD_TYPE.SEPA_DEBIT]: SEPADirectDebit,
  [PAYMENT_METHOD_TYPE.FPX]: FPX,
  [PAYMENT_METHOD_TYPE.BACS_DEBIT]: DEBIT_ICON,
  [PAYMENT_METHOD_TYPE.ACSS_DEBIT]: DEBIT_ICON,
  [PAYMENT_METHOD_TYPE.GRABPAY]: GrabPay,
  [PAYMENT_METHOD_TYPE.AFTERPAY_CLEARPAY]: AfterpayClearpay,
  [PAYMENT_METHOD_TYPE.AFFIRM]: Affirm,
  [PAYMENT_METHOD_TYPE.APPLE_PAY]: ApplePay,
  [PAYMENT_METHOD_TYPE.GOOGLE_PAY]: GooglePay,
  [PAYMENT_METHOD_TYPE.KLARNA]: Sofort,
  [PAYMENT_METHOD_TYPE.WECHAT_PAY]: WeChatPay,
  [PAYMENT_METHOD_TYPE.BOLETO]: Boleto,
  [PAYMENT_METHOD_TYPE.OXXO]: OXXO,
  [PAYMENT_METHOD_TYPE.AU_BECS_DEBIT]: DEBIT_ICON,
  [PAYMENT_METHOD_TYPE.US_BANK_ACCOUNT]: DEBIT_ICON,
  [PAYMENT_METHOD_TYPE.KONBINI]: Konbini
};
